<template>
  <GenInspect />
</template>

<script>
import GenInspect from '../../components/InspectSearch/GenInspect.vue'
export default {
    components:{
        GenInspect,
    }
}
</script>